import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";

export class CPageWidth extends BasicCPCLArg<CPageWidth> {
  private width: number;

  constructor(options?: {
    /**
     * 页面高度
     */
    width?: number
  }) {
    super();
    this.width = options?.width ?? 0;
  }

  clause(): CommandClause {
    return CPCLCommand.with(this.header())
      .appendNumber(this.width)
      .clause();
  }

  header(): string {
    return 'PAGE-WIDTH';
  }
}



